import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    document.addEventListener("turbo:render", this.onRender);
    document.addEventListener("turbo:frame-render", this.onFrameRender);
  }

  disconnect() {
    document.removeEventListener("turbo:render", this.onRender);
    document.removeEventListener("turbo:frame-render", this.onFrameRender);
  }

  // Turboによるレンダリング
  onRender() {
    const isPreview = document.documentElement.hasAttribute("data-turbo-preview");
    if (isPreview) return;

    // 最終レンダリング時にdataLayerにpushする
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "SPA_pageview",
      virtualPageUrl: window.location.href || "",
      virtualPageTitle: document.title || "LivePocket（ライブポケット）｜電子チケット予約・購入・イベント検索",
    });
  }

  // TurboFrameによるレンダリング
  onFrameRender(e) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "SPA_pageview",
      virtualPageUrl: e.detail.fetchResponse.response?.url || "",
      virtualPageTitle: document.title || "LivePocket（ライブポケット）｜電子チケット予約・購入・イベント検索",
    });
  }
}
